// extracted by mini-css-extract-plugin
export default {"link_detail":"cardFund_link_detail__uRllf","card":"cardFund_card__MII8F","img":"cardFund_img__C997X","name":"cardFund_name__7V31v"};